import React from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import type {ReactNode} from 'react';

interface Props {
  children: ReactNode;
  actionsChildren?: ReactNode;
  expandedChildren?: ReactNode;
  containerClass?: string;
  childrenClass?: string;
  expandedChildrenClass?: string;
}
export function ItemWithChildrenStructure({
  actionsChildren,
  children,
  childrenClass,
  expandedChildren,
  expandedChildrenClass,
  containerClass,
}: Props): JSX.Element {
  return (
    <StyledItemDiv className={cs(containerClass)}>
      <div className={cs('row no-gutters name-content', childrenClass)}>
        <div className="col d-flex justify-content-between align-items-center">
          {children}
        </div>
        {actionsChildren != null ? (
          <div className="col-auto py-2 px-2 d-flex align-items-center">
            {actionsChildren}
          </div>
        ) : null}
      </div>
      {expandedChildren != null ? (
        <div
          className={cs('tree-item-expanded-content', expandedChildrenClass)}
        >
          {expandedChildren}
        </div>
      ) : null}
    </StyledItemDiv>
  );
}

const StyledItemDiv = styled.div`
  .name-content:hover {
    background-color: #e9f7f9;
  }

  .kb-item-icon-container {
    flex-shrink: 0;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tree-item-expanded-content {
    height: auto;
    margin-left: 14px;
    padding-left: 14px;
    border-left: 2px dashed rgba(0, 0, 0, 0.25);
  }
`;
